import type { DashboardNowStats, DashboardPeriodStats } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { SummaryCard } from './summary-card';

interface DashboardSummaryCardsProps {
  readonly now: DashboardNowStats;
  readonly period: DashboardPeriodStats;
}

/**
 * 숫자 카드 넷 — 미처리 상담·진행 중 주문은 지금 쌓인 것, 발행 견적·신규 가입은 기간 탭이 걸린다(메모 §화면 구성).
 * 앞의 둘은 해당 목록으로 가는 링크다.
 */
export const DashboardSummaryCardsWidget = ({
  now,
  period,
}: DashboardSummaryCardsProps): ReactElement => (
  <section aria-label="요약" className="grid grid-cols-2 gap-3 lg:grid-cols-4">
    <SummaryCard
      label="미처리 상담"
      count={now.pendingQuotes.total}
      unit="건"
      detail={`검토 대기 ${now.pendingQuotes.requested} · 수정 요청 ${now.pendingQuotes.revisionRequested}`}
      to="/quotes"
    />
    <SummaryCard label="발행 견적" count={period.issuedQuotes} unit="건" detail="선택한 기간" />
    <SummaryCard
      label="진행 중 주문"
      count={now.inProgressOrders.total}
      unit="건"
      detail={`제작 대기 ${now.inProgressOrders.waiting} · 제작 중 ${now.inProgressOrders.inProduction} · 배송 중 ${now.inProgressOrders.shipped}`}
      to="/orders"
    />
    <SummaryCard
      label="신규 가입"
      count={period.newUsers.total}
      unit="명"
      detail={`이메일 ${period.newUsers.email} · 소셜 ${period.newUsers.social}`}
    />
  </section>
);
